import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_SETTINGS: createActionType(FULL_NAMESPACE, "GET_SETTINGS"),
    GET_SETTINGS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_SETTINGS_COMPLETED"),
    GET_SETTINGS_TYPE_DICTIONARY: createActionType(FULL_NAMESPACE, "GET_SETTINGS_TYPE_DICTIONARY"),
    GET_SETTINGS_TYPE_DICTIONARY_COMPLETED: createActionType(FULL_NAMESPACE, "GET_SETTINGS_TYPE_DICTIONARY_COMPLETED"),
    SAVE_SETTING: createActionType(FULL_NAMESPACE, "SAVE_SETTING"),
    SAVE_SETTING_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_SETTING_COMPLETED"),
    SAVE_SETTING_REJECTED: createActionType(FULL_NAMESPACE, "SAVE_SETTING_REJECTED"),
    SAVE_CONNECTION: createActionType(FULL_NAMESPACE, "SAVE_CONNECTION"),
    SAVE_CONNECTION_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_CONNECTION_COMPLETED"),
    SAVE_CONNECTION_REJECTED: createActionType(FULL_NAMESPACE, "SAVE_CONNECTION_REJECTED"),
    TEST_CONNECTION: createActionType(FULL_NAMESPACE, "TEST_CONNECTION"),
    TEST_CONNECTION_COMPLETED: createActionType(FULL_NAMESPACE, "TEST_CONNECTION_COMPLETED"),
    TEST_CONNECTION_REJECTED: createActionType(FULL_NAMESPACE, "TEST_CONNECTION_REJECTED"),
    RELOAD_ONTOLOGY: createActionType(FULL_NAMESPACE, "RELOAD_ONTOLOGY"),
    RELOAD_ONTOLOGY_COMPLETED: createActionType(FULL_NAMESPACE, "RELOAD_ONTOLOGY_COMPLETED"),
    RELOAD_ONTOLOGY_REJECTED: createActionType(FULL_NAMESPACE, "RELOAD_ONTOLOGY_REJECTED")
};
